import { RoundingTypes } from '../types/rounding.types';

export interface IRoundingPreferences {
  label: string;
  value: RoundingTypes;
}
